export const getIsAirBnb = (state) => {
  const search = state?.router?.location?.search;
  const searchType = search.split('&');
  return searchType.some((el) => el === 'searchType=airbnb');
};
